import { useUser } from 'lib/auth';
import { Tenant } from 'utils/tenants';

import { useOrganizationById } from './useOrganizationById';

export const useUserOrganization = () => {
  const user = useUser();
  const { organizationData, error, isLoading } = useOrganizationById({
    organizationId: user?.organizationId,
    tenantId: user?.tenantId as Tenant,
  });

  return { organizationData, error, isLoading };
};
